import { Component, OnInit, TemplateRef } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { AppService } from "../services/app.service";
import { FormControl } from "@angular/forms";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/throttleTime";
import "rxjs/add/observable/fromEvent";
import { Subscription } from "rxjs";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import { PatientListService } from "../services/patient-list.service";

@Component({
  selector: "app-patient-info",
  templateUrl: "./patient-info.component.html",
})
export class PatientInfoComponent implements OnInit {
  modalRef: BsModalRef;
  rowsData = [
    {
      title: "First Name",
      sorting: true,
      name: "patientFirstName",
      underline: true,
    },
    {
      title: "Last Name",
      sorting: true,
      name: "patientLastName",
      underline: true,
    },
    { title: "Address", tooltip: true },
    { title: "Mobile Number" },
    { title: "Email", sorting: true, name: "patientEmail" },
    { title: "Patient Type" },
  ];

  columnsData = [];
  columnsRes = [];
  p = 1;
  totalItems: any;
  currentPage = 1;
  page: number;
  maxSize = 10;
  maxSizeItem = 10;
  firstNameControl = new FormControl();
  formCtrlSub: Subscription;
  searchPatient = "";
  sortColumn = "patientCreatedOn";
  orderColumn = "desc";
  searchText = "";
  alphaVal = "all";
  routerName = "";
  maxSizeItemValue: any;

  constructor(
    private modalService: BsModalService,
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private patientListService: PatientListService
  ) {}

  ngOnInit() {
    this.patientListService.init(this);
  }

  checkUrl() {
    this.patientListService.checkUrl(this);
  }

  onBlurMethod(val) {
    this.patientListService.onBlurMethod(this, val);
  }

  alphaSearch(val) {
    if (val !== "all") {
      this.searchPatient = val;
    } else {
      this.searchPatient = "";
    }
    this.alphaVal = val;
    this.searchText = "";
    this.getPatientList("");
  }

  onBlurSearchMethod() {
    this.patientListService.onBlurSearchMethod(this);
  }

  getPatientList(event) {
    const data = this.patientListService.buildRequest(this, event, "all");
    this.patientListService.loadPatients(this, data, (obj) => {
      const address = this.patientListService.buildAddress(obj);
      return {
        param1: obj.patientFirstName,
        param2: obj.patientLastName,
        param3: address ? address : "-",
        param4:
          obj.patientPhone && obj.patientPhoneCode === "+91"
            ? this.patientListService.formatPhoneIn(
                obj.patientPhone,
                obj.patientPhoneCode
              )
            : obj.patientPhone && obj.patientPhoneCode === "+1"
            ? this.patientListService.formatPhoneUs(
                obj.patientPhone,
                obj.patientPhoneCode
              )
            : "-",
        param5: obj.patientEmail !== "null" ? obj.patientEmail : "-",
        param6: obj.patientType
          ? obj.patientType === "Sched" || obj.patientType === "Mobile"
            ? "SchedMed"
            : "IC"
          : "SchedMed",
        param12: obj.id,
        param11: obj.patientId,
        param13: "Double click for view",
      };
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({ class: "modal-xl" })
    );
  }

  pageChanged(event: any): void {
    this.patientListService.pageChanged(this, event);
  }
}
